@if (visible) {
  <div class="filter-container">
    @if (!available) {
      <div class="no-filters-message">
        {{ noFiltersAvailableLabel }}
      </div>
    }
    @if (available) {
      <!-- Add clear all button in top right -->
      @if (activeFilters.length > 0) {
        <button
          mat-icon-button color="primary"
          class="clear-all-button"
          [matTooltip]="clearFilterTooltip"
          (click)="clearAllFilters()">
          <mat-icon>filter_list_off</mat-icon>
        </button>
      }
    }
    @if (available) {
      <!-- Active filters as chips - use merged filters for display -->
      <div class="filter-chips">
        @if (activeFilters.length > 0) {
          <mat-chip-set>
            @for (filter of getActiveFiltersForDisplay(); track filter) {
              <mat-chip
                removable="true"
                (removed)="removeFilter(filter)"
                (click)="editFilter(filter, $event)">
                {{ filter.fieldKey.label }}: {{ getFilterDisplayValue(filter) }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
            }
          </mat-chip-set>
        }
      </div>
      <!-- Field selector panel - always visible -->
      <div class="field-selector-panel">
        <!-- Field selection dropdown -->
        <mat-form-field appearance="outline" class="field-dropdown">
          <mat-label>{{ selectedField ? fieldLabel : selectFieldLabel }}</mat-label>
          <mat-select [(ngModel)]="selectedField" (selectionChange)="selectField(selectedField!)"
            [disableOptionCentering]="true" [placeholder]="selectFieldLabel">
            @if (hasConceptFields) {
              <mat-optgroup [label]="conceptLevelFieldsLabel">
                @for (filter of getConceptFields(); track filter) {
                  <mat-option [value]="filter">
                    {{ filter.fieldKey.label }}
                  </mat-option>
                }
              </mat-optgroup>
            }
            @if (hasTermFields) {
              <mat-optgroup [label]="termLevelFieldsLabel">
                @for (filter of getTermFields(); track filter) {
                  <mat-option [value]="filter">
                    {{ filter.fieldKey.label }}
                  </mat-option>
                }
              </mat-optgroup>
            }
          </mat-select>
        </mat-form-field>
        <!-- Field values (conditional based on field type) -->
        @if (selectedField) {
          <div class="field-values">
            <!-- Text field -->
            @if (!selectedField.picklistItems) {
              <div class="text-field-container">
                <mat-form-field appearance="outline" class="search-text-field">
                  <mat-label>{{ searchForLabel }}</mat-label>
                  <input matInput [(ngModel)]="tempSearchText"
                    [matTooltip]="pressEnterTooltip" [errorStateMatcher]="matcher"
                    (keyup.enter)="updateTextFilter()">
                  <mat-hint>{{ searchHintLabel }}</mat-hint>
                  @if (tempSearchText.trim().length > 0 && tempSearchText.trim().length < 2) {
                    <mat-error>
                      {{ minCharactersErrorLabel }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            }
            <!-- Picklist field -->
            @if (selectedField.picklistItems) {
              <div class="checkbox-container">
                @for (item of selectedField.picklistItems; track item) {
                  <div class="row">
                    <mat-checkbox [(ngModel)]="tempSelectedValues[item.value]"
                      (change)="updatePicklistFilter()">
                      {{ item.name }}
                    </mat-checkbox>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}
